import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { withAssetPrefix } from 'gatsby';

import _ from 'lodash';

import {
  classnames,
  classname
} from 'utils';
import { GetSponsors } from 'query';

import './Sponsors.css';

class Sponsors extends Component {
  cl = classname('sponsors');

  constructor(props) {
    super(props);

    const firstSliderNames = ['pml', 'medialogy', 'cityads', 'millennium'];
    const firstSliderItems = [];

    const { data } = props;
    const tmpData = _.cloneDeep(data);

    firstSliderNames.forEach((name) => {
      const foundedIndex = tmpData.findIndex(({ id }) => id === name);
      if (foundedIndex > -1) {
        firstSliderItems.push(...tmpData.splice(foundedIndex, 1));
      }
    });

    const finalData = [...firstSliderItems, ..._.shuffle(tmpData)];

    this.state = { data: finalData, step: 0 };
  }

  shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const num = Math.floor(Math.random() * (i + 1));
      const d = array[num];

      array[num] = array[i];
      array[i] = d;
    }
    return array;
  }

  update(step) {
    let { data } = this.state;

    if (data.length <= (step + 1) * this.count) {
      data = _.shuffle(data).sort((a, b) => b.weight - a.weight);
    }

    this.setState({ data, step });

    setTimeout(() => {
      this.update(step + 1);
    }, 1000 * 10);
  }

  componentDidMount() {
    if (process.browser) {
      this.count = window.innerWidth >= 768 ? 6 : 3;
      this.update(0);
    }
  }

  render() {
    const { className } = this.props;
    const { data } = this.state;
    const classes = classnames(className, this.cl());

    return (
      <>
        <div className={classes}>
          <div className={this.cl('wrapper')}>
            <ul className={this.cl('list')}>
              {
                data.filter((el, idx) => idx < this.count).map(({ id, link, title }, index) => {
                  const Tag = link ? 'a' : 'div';
                  const attrs = link ? { href: link, target: '_blank' } : {};

                  return (
                    <li key={id}
                        className={[this.cl('item'), this.count === 6 ? `${this.cl('item')}-${index}` : ''].join(' ')}>
                      <Tag {...attrs} className={this.cl('link')}>
                        <img title={title} className={this.cl('logo')} src={withAssetPrefix('/sponsors/' + id + '.png')}
                             alt=""/>
                      </Tag>
                    </li>
                  );
                })
              }
            </ul>
          </div>
        </div>
        {/*добавляем правую и левую панель, если 6 элементов*/}
        {
          this.count === 6 && ReactDOM.createPortal(
            <>
              <SponsorsSides side={`${this.cl('side')}_left ${this.cl('side')}`}/>
              <SponsorsSides side={`${this.cl('side')}_right ${this.cl('side')}`}/>
            </>,
            document.querySelector('#gatsby-focus-wrapper')
          )
        }
      </>
    );
  }
}

function SponsorsSides(props) {
  return (
    <div className={props.side}/>
  );
}


export default props => <GetSponsors>{data => <Sponsors data={data} {...props} />}</GetSponsors>;
